import { useIntl } from "react-intl";
import ResponsiveAssetListAuto from "../../../common/features/asset/ResponsiveAssetListAuto.tsx";
import DefaultTemplate from "../layout/content-templates/default/DefaultTemplate.tsx";
import { useState } from "react";
import EmptyLibrary from "./EmptyLibrary.tsx";
import OnboardingBanner from "../common/onboarding-banner/OnboardingBanner.tsx";
import MiscellaneousBook from "../../../common/icons/MiscellaneousBook.tsx";
import { LoadableLibraryAssetChunk } from "./LoadableLibraryAssetChunk.tsx";
import PaginatedAssetFetcherStatus from "../common/asset-load/PaginatedAssetFetcherStatus.tsx";
import usePaginatedAssetFetcherStatus from "../common/asset-load/usePaginatedAssetFetcherStatus.ts";
import { Fetcher } from "react-router-dom";
import useStateArray from "../../../common/core-ui/useStateArray.ts";
import { UserPreferenceKey } from "../../../common/api/decimal/methods/user.ts";
import PageTitle from "../common/page-title/PageTitle.tsx";
import HelpDialogSwitcher from "../common/help/HelpDialogSwitcher.tsx";
import { useBrandLoaderData } from "routes/root/rootLoader.ts";

export default function MyLibrary() {
  const intl = useIntl();
  const brand = useBrandLoaderData();
  const [pageCount, setPageCount] = useState(1);
  const [isShowingHelp, setIsShowingHelp] = useState(false);
  const [fetchers, updateFetcher] = useStateArray<Fetcher>();
  const { contentLengthStatus } = usePaginatedAssetFetcherStatus(fetchers);
  const title = intl.formatMessage({ defaultMessage: "My Library" });
  return (
    <DefaultTemplate title={title}>
      {contentLengthStatus === "has-content" &&
        brand.MyLibraryBanner.enabled && (
          <OnboardingBanner
            icon={<MiscellaneousBook />}
            title={intl.formatMessage({
              defaultMessage: "Quickly Access Your Content",
            })}
            body={intl.formatMessage({
              defaultMessage:
                "Not seeing what you expect? You may need to redeem a code or double check the email associated with your VitalSource account.",
            })}
            linkText={intl.formatMessage({ defaultMessage: "Learn More" })}
            onClick={() => setIsShowingHelp(true)}
            bannerSeenPreferenceKey={
              UserPreferenceKey.MyLibraryOnboardingBannerDismissed
            }
          />
        )}
      <PageTitle title={title} />
      <ResponsiveAssetListAuto>
        {Array.from({ length: pageCount }).map((_, i) => (
          <LoadableLibraryAssetChunk
            page={i + 1}
            key={i}
            onSetFetcher={(fetcher) => {
              updateFetcher(fetcher, i);
            }}
          />
        ))}
      </ResponsiveAssetListAuto>
      <PaginatedAssetFetcherStatus
        fetchers={fetchers}
        onShowMore={() => setPageCount((count) => count + 1)}
        emptyState={<EmptyLibrary />}
      />
      {isShowingHelp && (
        <HelpDialogSwitcher onRequestClose={() => setIsShowingHelp(false)} />
      )}
    </DefaultTemplate>
  );
}
